export default __webpack_public_path__ + "static/media/scales-logo.a6ec7440.png";